// import classNames from 'classnames';
import { forwardRef, PropsWithChildren } from 'react';

import IconButton from '../IconButton';
import Close from '../icons/Close';

import style from './dialog.module.css';

const Dialog = forwardRef<HTMLDialogElement, PropsWithChildren>(
  ({
    children,
  }, ref) => {
    return (
      <dialog
        className={style.dialog}
        ref={ref}
      >
        <div className={style.closeButtonContainer}>
          <form method="dialog">
            <IconButton aria-label="Close dialog">
              <Close iconColor="black" />
            </IconButton>
          </form>
        </div>

        {children}
      </dialog>
    );
  },
);

export default Dialog;
